var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51375 15.5794C9.31664 15.5794 9.11953 15.5094 8.96392 15.3594C8.66307 15.0694 8.66307 14.5894 8.96392 14.2994L14.8357 8.63938C15.1365 8.34938 15.6345 8.34938 15.9353 8.63938C16.2362 8.92937 16.2362 9.40937 15.9353 9.69937L10.0636 15.3594C9.91834 15.5094 9.71086 15.5794 9.51375 15.5794Z",
    fill: "#1B2831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3855 15.5794C15.1884 15.5794 14.9913 15.5094 14.8357 15.3594L8.96392 9.69937C8.66307 9.40937 8.66307 8.92937 8.96392 8.63938C9.26477 8.34938 9.76273 8.34938 10.0636 8.63938L15.9353 14.2994C16.2362 14.5894 16.2362 15.0694 15.9353 15.3594C15.7797 15.5094 15.5826 15.5794 15.3855 15.5794Z",
    fill: "#1B2831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.ccef4c155811916d5d51a2ac778b836a.svg";
export { ForwardRef as ReactComponent };